import { useEffect, useRef } from 'react'
import { Download } from 'lucide-react'
import { useCVModal } from '../contexts/CVModalContext'
import { initGSAP, prefersReducedMotion } from '../lib/motion'
import ContactForm from './ContactForm'
import SectionHeading from './SectionHeading'

const Contact: React.FC = () => {
  const { openModal } = useCVModal()
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (prefersReducedMotion()) return
    const gsapApi = initGSAP()
    const ctx = gsapApi.context(() => {
      gsapApi.fromTo(
        '[data-contact]',
        { opacity: 0, y: 24 },
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          ease: 'power2.out',
          scrollTrigger: { trigger: ref.current, start: 'top 80%', once: true },
        }
      )
    }, ref)
    return () => ctx.revert()
  }, [])

  return (
    <section id="contact" ref={ref} className="section-padding">
      <div className="container-width">
        <div data-contact className="max-w-2xl">
          <SectionHeading
            label="Contact"
            meta="get in touch"
            title={
              <>
                Let's build something
                <span className="text-gradient block">reliable together.</span>
              </>
            }
            description={
              <>
                I'm open to Junior Platform Engineer, DevOps, Cloud, DevSecOps
                and SRE roles — especially around Kubernetes, Terraform and
                CI/CD.
              </>
            }
          />

          <ContactForm />

          <div className="mt-10 text-center">
            <button
              onClick={openModal}
              className="btn-secondary px-6 py-3 text-base"
            >
              <Download size={16} />
              Download CV
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact